var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempsB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.91 250L31.0601 173.62L31.25 33.5701L163.11 109.94L162.91 250Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.05 154.57L31.1899 78.1901L31.2499 33.5701L163.11 109.94L163.05 154.57Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2198 114.91L41.4199 102.28L41.4498 81.21L63.2499 93.83L63.2198 114.91Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0601 132.19L71.25 119.56L71.28 98.49L93.09 111.11L93.0601 132.19Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.89 149.47L101.09 136.84L101.12 115.77L122.92 128.39L122.89 149.47Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 166.75L130.93 154.13L130.95 133.05L152.76 145.68L152.73 166.75Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1899 141.72L41.3799 129.09L41.4099 108.01L63.2198 120.64L63.1899 141.72Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0198 159L71.2197 146.37L71.2498 125.29L93.0498 137.92L93.0198 159Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 176.28L101.05 163.65L101.08 142.57L122.88 155.2L122.86 176.28Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M152.69 193.56L130.89 180.93L130.92 159.85L152.72 172.48L152.69 193.56Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1499 168.53L41.3398 155.9L41.3699 134.82L63.1799 147.45L63.1499 168.53Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9801 185.81L71.1802 173.18L71.2101 152.1L93.0101 164.73L92.9801 185.81Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.82 203.09L101.02 190.46L101.05 169.38L122.85 182.01L122.82 203.09Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 100.53L163.11 109.94L162.91 250L179.23 240.59L179.42 100.53Z",
    fill: "#29A063"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5601 24.1599L31.25 33.5699L163.11 109.94L179.42 100.53L47.5601 24.1599Z",
    fill: "#72D09A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.88 123.97C126.65 120.94 122.4 113.57 122.41 107.53L122.43 91.5202C122.43 88.5002 123.5 86.3802 125.22 85.4002C126.94 84.4102 129.31 84.5602 131.93 86.0702C137.16 89.1002 141.41 96.4701 141.4 102.51L141.38 118.52C141.38 121.54 140.31 123.65 138.59 124.64C136.87 125.63 134.49 125.48 131.88 123.97Z",
    fill: "#72D09A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.57 86.8301C168.57 80.8001 164.33 73.4201 159.1 70.3901C156.48 68.8701 154.1 68.7301 152.38 69.7201L130.67 82.2702L125.22 85.4002C126.94 84.4102 129.31 84.5602 131.93 86.0702C137.16 89.1002 141.41 96.4701 141.4 102.51L141.38 118.52C141.38 121.54 140.31 123.65 138.59 124.64L144.05 121.5C145.77 120.51 146.84 118.39 146.84 115.38L146.86 99.3801V100.51L163.16 91.0901L168.57 94.2301V87.9701V86.8401V86.8301Z",
    fill: "#29A063"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4797 77.4402C46.2497 74.4102 42.0098 67.0401 42.0098 61.0101L42.0298 45.0001C42.0298 41.9801 43.0998 39.8601 44.8198 38.8801C46.5398 37.8901 48.9098 38.0402 51.5298 39.5502C56.7598 42.5802 61.0098 49.9501 60.9998 55.9901L60.9797 72.0001C60.9797 75.0101 59.9098 77.1301 58.1898 78.1201C56.4698 79.1101 54.0897 78.9601 51.4797 77.4501V77.4402Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6997 23.8602C76.0797 22.3402 73.6997 22.2002 71.9797 23.1902L50.2698 35.7402L44.8198 38.8702C46.5398 37.8802 48.9098 38.0302 51.5298 39.5402C56.7598 42.5702 61.0098 49.9402 60.9998 55.9802L60.9797 71.9902C60.9797 75.0002 59.9098 77.1202 58.1898 78.1102L63.6498 74.9701C65.3698 73.9801 66.4298 71.8602 66.4398 68.8502L66.4597 53.9702L82.7598 44.5502L88.1698 47.7101V40.2802C88.1798 34.2502 83.9297 26.8701 78.6997 23.8401V23.8602Z",
    fill: "#29A063"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 49.1152C147.468 41.2051 149.787 37.9092 149.787 32.9775C149.787 25.0918 143.513 22.3574 136.896 22.3574C133.015 22.3574 129.694 23.3096 126.789 24.7012L127.717 31.3662C129.426 30.3652 133.063 29.291 136.018 29.291C138.85 29.291 141.438 30.1211 141.438 33.5635C141.438 35.8828 140.192 38.1533 137.58 40.4482L126.496 50.1406V56H150.739V49.1152H137.141Z",
    fill: "#F97E73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.661 39.6914H152.863V45.6484H170.661V39.6914Z",
    fill: "#F97E73"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.108 56H187.141V22.8457H171.32V29.7549H179.108V56Z",
    fill: "#F97E73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.619 56.4883C210.7 56.4883 216.584 53.1191 216.584 44.9648C216.584 37.9336 210.48 34.4668 203.01 34.4668C202.033 34.4668 201.032 34.54 200.544 34.6133L201.081 29.7549H215.144V22.8457H194.733L192.561 40.4238L194.074 41.6934C196.149 40.9854 198.566 40.6436 201.154 40.6436C205.72 40.6436 208.015 42.3037 208.015 45.2822C208.015 48.2363 205.915 49.6279 201.691 49.6279C198.688 49.6279 195.49 48.9443 192.414 47.3574L191.291 54.1689C194.392 55.6094 198.469 56.4883 202.619 56.4883Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempsB);
export default __webpack_public_path__ + "static/media/tempsB.5c8f8708bff6bab47ba6a56001110d92.svg";
export { ForwardRef as ReactComponent };